export default __webpack_public_path__ + "static/media/lightning.12610a50.gif";